import { StyleSheet } from 'aphrodite';
import {
	antiFlashWhite,
	background,
	brandPrimaryDark,
	brandPrimaryHoverTint,
	brandPrimaryText,
	darkGrayFontColor,
	destructive,
	errorLight,
	header,
	midGray,
	success,
	successTint,
	titles,
	warningLight,
} from '../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	dialog: {
		maxWidth: '900px',
		width: '90vw',
		maxHeight: '80vh',
	},
	dialogBody: {
		overflowY: 'auto',
		maxHeight: 'calc(80vh - 120px)',
	},
	loadingContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		padding: '32px',
	},
	loadingText: {
		marginLeft: '16px',
	},
	noDataMessage: {
		padding: '24px',
		textAlign: 'center',
		color: header,
		fontSize: '14px',
		maxWidth: '600px',
		margin: '0 auto',
	},
	errorMessage: {
		padding: '12px',
		backgroundColor: errorLight,
		color: destructive,
		borderRadius: '4px',
		marginBottom: '16px',
	},
	backButton: {
		display: 'flex',
		alignItems: 'center',
		gap: '8px',
		background: 'none',
		border: 'none',
		color: brandPrimaryText,
		fontSize: '14px',
		fontWeight: 600,
		cursor: 'pointer',
		padding: '8px 0',
		marginBottom: '16px',
		':hover': {
			opacity: 0.8,
		},
	},
	meetingCard: {
		marginBottom: '12px',
		padding: '16px',
		backgroundColor: background,
		borderRadius: '4px',
		border: `1px solid ${midGray}`,
		cursor: 'pointer',
		transition: 'background-color 0.15s ease',
		':hover': {
			backgroundColor: antiFlashWhite,
		},
	},
	meetingCardHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'flex-start',
		gap: '16px',
	},
	meetingTitle: {
		fontSize: '16px',
		fontWeight: 600,
		color: header,
		marginBottom: '8px',
	},
	meetingMeta: {
		fontSize: '13px',
		color: darkGrayFontColor,
		marginBottom: '4px',
	},
	meetingStatus: {
		display: 'inline-block',
		padding: '4px 8px',
		borderRadius: '4px',
		fontSize: '12px',
		fontWeight: 600,
	},
	statusCompleted: {
		backgroundColor: successTint,
		color: success,
	},
	statusScheduled: {
		backgroundColor: brandPrimaryHoverTint,
		color: brandPrimaryDark,
	},
	statusCancelled: {
		backgroundColor: errorLight,
		color: destructive,
	},
	statusDefault: {
		backgroundColor: antiFlashWhite,
		color: titles,
	},
	viewRecordingsLink: {
		color: brandPrimaryText,
		fontSize: '13px',
		fontWeight: 600,
		textDecoration: 'underline',
		flexShrink: 0,
	},
	// Transcript card styles (adapted from LogMeetingNotes)
	transcriptCard: {
		marginBottom: '16px',
		padding: '16px',
		backgroundColor: background,
		borderRadius: '4px',
		border: `1px solid ${midGray}`,
	},
	transcriptCardHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'flex-start',
		gap: '16px',
	},
	transcriptTopic: {
		fontSize: '16px',
		fontWeight: 600,
		color: header,
		marginBottom: '8px',
	},
	transcriptMeta: {
		fontSize: '13px',
		color: darkGrayFontColor,
		marginBottom: '4px',
	},
	transcriptReasons: {
		fontSize: '12px',
		color: darkGrayFontColor,
		fontStyle: 'italic',
		marginTop: '4px',
	},
	transcriptDivider: {
		margin: '0 8px',
	},
	pipeDivider: {
		margin: '0 10px',
		color: darkGrayFontColor,
	},
	fullWidth: {
		flex: 1,
	},
	matchScore: {
		display: 'inline-block',
		padding: '4px 8px',
		borderRadius: '4px',
		fontSize: '12px',
		fontWeight: 600,
	},
	matchScoreHigh: {
		backgroundColor: successTint,
		color: success,
	},
	matchScoreMedium: {
		backgroundColor: warningLight,
		color: header,
	},
	matchScoreLow: {
		backgroundColor: errorLight,
		color: destructive,
	},
	transcriptCardFooter: {
		display: 'flex',
		justifyContent: 'flex-end',
		marginTop: '12px',
		paddingTop: '12px',
		borderTop: `1px solid ${midGray}`,
	},
	viewTranscriptLink: {
		background: 'none',
		border: 'none',
		color: darkGrayFontColor,
		fontSize: '12px',
		fontWeight: 'normal',
		cursor: 'pointer',
		textDecoration: 'underline',
		padding: 0,
		':hover': {
			opacity: 0.8,
		},
	},
	expandedContent: {
		marginTop: '16px',
		paddingTop: '16px',
		borderTop: `1px solid ${midGray}`,
	},
	transcriptContent: {
		marginTop: '16px',
		padding: '16px',
		backgroundColor: 'white',
		borderRadius: '4px',
		border: `1px solid ${midGray}`,
		maxHeight: '400px',
		overflowY: 'auto',
		whiteSpace: 'pre-wrap',
		fontSize: '13px',
		lineHeight: '1.6',
	},
});
